// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b146144","239":"4cd860a8","667":"f0e56d9f"}[chunkId] + ".chunk.js";
};